import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from './FormControl';
import { Grid } from '@material-ui/core';
var styles = {};

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Form);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Form)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.childRefs = [], _this.state = {
      isValid: false
    }, _this.validateForm = function () {
      var onSubmit = _this.props.onSubmit;
      var flag = true;

      _this.childRefs.forEach(function (children) {
        if (children && children.validate !== undefined) {
          var result = children.validate();
          flag &= result;
        }

        _this.setState({
          isValid: flag
        });
      });

      if (flag && onSubmit) {
        onSubmit();
      }
    }, _this.handleKeyPress = function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();

        _this.validateForm();
      }
    }, _temp));
  } // Dispatch imperative functions to
  // the child components and force the
  // Validation


  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          lazyValidation = _props.lazyValidation,
          other = _objectWithoutProperties(_props, ['children', 'lazyValidation']);

      var childArray = React.Children.toArray(children);
      return React.createElement(Grid, _extends({
        container: true
      }, other, {
        onKeyPress: this.handleKeyPress
      }), React.Children.map(childArray, function (ch, idx) {
        // Check if the child is a FormControl,
        // Add the necessary functions to it.
        if (ch.type === FormControl) {
          return React.cloneElement(ch, {
            onSubmit: _this2.validateForm
          });
        } // Check if the child is a button with
        // Type submit and add the onSubmit function


        if (ch.props && ch.props.type === 'submit') {
          return React.cloneElement(ch, {
            onClick: _this2.validateForm
          });
        }

        if (ch.props && ch.props.className === 'form-ignore') {
          return React.cloneElement(ch);
        } // Save the ref for all the other components


        return React.cloneElement(ch, {
          lazyValidation: lazyValidation,
          innerRef: function innerRef(ref) {
            return _this2.childRefs.push(ref);
          }
        });
      }));
    }
  }]);

  return Form;
}(Component);

export default withStyles(styles)(Form);